import React, { useState, useEffect } from "react";
import { Tooltip, IconButton } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import LinkIcon from "@material-ui/icons/Link";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import axios from "../../AxiosClient";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";

function SearchResolution(props) {
  const [resolutionId, setResolutionId] = useState("");
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();
  const theme = useTheme();

  useEffect(
    () => {
      if (props.resolutions && props.resolutions.length === 0) {
        //resolutions have been reset
        setResolutionId("")
      }
    },[props.resolutions]
  )

  const resolveSearchWithResult = () => {
    let obj = {
      searchId: props.searchId,
      documentId: props.documentId,
      resultPosition: props.position,
      score: props.score,
    };

    axios
      .post(`/search/resolutions/`, obj)
      .then((res) => {
        setResolutionId(res.data);
        props.onResolution && props.onResolution(res.data);
      })
      .catch(() => {
        enqueueSnackbar(t("error_occurred_generic"), { variant: "error" });
      });
  };

  const unresolveSearchWithResult = (e) => {
    axios
      .delete(`/search/${props.searchId}/resolutions/${resolutionId}`)
      .then((res) => {
        props.onUnResolved && props.onUnResolved(resolutionId);
        setResolutionId("");
      })
      .catch(() => {
        enqueueSnackbar(t("error_occurred_generic"), { variant: "error" });
      });
  };

  return (
    <Tooltip
      title={
        resolutionId === "" ? "Link this document to this search" : "Unlink"
      }
      enterDelay={300}
    >
      <IconButton
        disabled={!props.searchId}
        data-testid="link-document-to-search"
        id={`link-doc-to-search-${props.documentId}`}
        onClick={
          resolutionId === ""
            ? resolveSearchWithResult
            : unresolveSearchWithResult
        }
      >
        {resolutionId === "" ? (
          <LinkIcon />
        ) : (
          <CheckCircleIcon
            id="search-document-linked"
            alt="Linked to search"
            style={{ color: theme.palette.success.main }}
          />
        )}
      </IconButton>
    </Tooltip>
  );
}

export default SearchResolution;
